import { render, staticRenderFns } from "./sale_receivable_summary_list.vue?vue&type=template&id=4ff926e9"
import script from "./sale_receivable_summary_list.vue?vue&type=script&lang=js"
export * from "./sale_receivable_summary_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports